import { gql } from '@apollo/client';

export const MUTATION_CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      user {
        photoURL
        phoneNumber
        emailVerified
        email
        displayName
        uid
        role
      }
      access_token
    }
  }
`;

export const MUTATION_LOGIN_USER = gql`
  mutation LoginUser($input: LoginInput!) {
    loginUser(input: $input) {
      user {
        photoURL
        phoneNumber
        emailVerified
        email
        displayName
        uid
        role
      }
      access_token
    }
  }
`;

export const MUTATION_UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        uid
        email
        displayName
        photoURL
        phoneNumber
        emailVerified
        disabled
      }
    }
  }
`;
